<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-bg-repeat-x tw-bg-top tw-pb-24 tw-overflow-y-auto"
  #scrollContainer>
  <div class="tw-flex-1 tw-shrink-0 tw-w-full tw-px-6 tw-pt-9 tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-center tw-gap-2">
    <div class="tw-w-fit tw-flex tw-items-center tw-gap-2">
      <p class="tw-font-lexend tw-font-normal tw-text-300 tw-uppercase" i18n="@@youAreVerified">You are verified</p>
      <cs-icon class="tw-w-3 tw-h-3 tw-text-teal-600" [iconName]="'green_tick_circle'"></cs-icon>
    </div>
    <div class="tw-font-lexend tw-font-bold tw-text-gray-800"
      [class.tw-text-700]="isDravidianScriptUser"
      [class.tw-text-800]="!isDravidianScriptUser"
    i18n="@@tellUsAboutYour">Tell us a little about you</div>
  </div>
  <div class="tw-flex-none tw-rounded-tr-5 tw-rounded-tl-5 tw-px-6 tw-pt-7 tw-pb-7 tw-bg-white">
    <div class="tw-font-lexend tw-text-gray-800 tw-mb-2 tw-text-200"
      [ngClass]="conn.getClassBasedOnLanguagePreference()"
    i18n="@@tellUsYourName"> Tell us your name </div>
    <input class="tw-h-12 tw-flex tw-bg-gray-80 tw-rounded-2.5 tw-border tw-border-solid tw-border-gray-300 tw-m-0 placeholder:tw-text-300 placeholder:tw-font-normal placeholder:tw-text-left tw-w-full tw-font-body tw-text-300 tw-text-gray-800 tw-px-3"
      #nameInput=""
      name="patientName"
      autocomplete="off"
      type="text"
      autofocus="autofocus"
      id="nameInput"
      placeholder="Full Name"
      i18n-placeholder="@@fullName"
      [(ngModel)]="patientName"
      (keyup)="onNameChange()"
      [ngClass]='{ "tw-border-teal-400": patientName.length > 0 && !nameError, "tw-border-orange-500": nameError }'
      (paste)="onInputPaste($event)" />
    @if (nameError) {
      <div class="tw-flex tw-mt-2"
        id="nameError">
        <img src="/assets/images/warn-err.png"
          style="height: 18px"
          alt="warning" />
        @if (nameErrorMessage === GenderFormErrorMessages.numberInName) {
          <div class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@nameErrorSpecialCharactersV2">Enter only letters in your name. Do not use numbers or special characters (like &#64;, #, /, ,).</div>
        }
        @if (nameErrorMessage === GenderFormErrorMessages.emptyName) {
          <div class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@nameErrorEmptyNameV2">Enter your name to continue</div>
        }
        @if (nameErrorMessage === GenderFormErrorMessages.maxNameLength) {
          <div class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@nameErrorLengthLimitV2">Please enter only up to 3 words in your name</div>
        }
      </div>
    }
    <div class="tw-mt-6 tw-font-lexend tw-text-gray-800 tw-mb-[10px] tw-text-200"
      [ngClass]="conn.getClassBasedOnLanguagePreference()"
    i18n="@@chooseYourGender"> Choose your gender </div>
    <div class="tw-flex tw-items-start tw-gap-6"
      id="genderSelection">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 female"
        (click)="markGenderTo(appConfig.Shared.Gender.FEMALE)">
        <img class="tw-w-[88px] tw-h-auto tw-opacity-40 tw-grayscale"
          [ngClass]="{'tw-hidden': gender !== appConfig.Shared.Gender.MALE}"
          src="https://cdn.cureskin.com/app/img/female_plain.svg"
          alt="female deselected" />
        <img class="tw-w-[88px] tw-h-auto tw-grayscale"
          [ngClass]="{'tw-hidden': gender === appConfig.Shared.Gender.FEMALE || gender === appConfig.Shared.Gender.MALE}"
          src="https://cdn.cureskin.com/app/img/female_plain.svg"
          alt="female deselected" />
        <img class="tw-w-[88px] tw-h-auto"
          [ngClass]="{'tw-hidden': gender !== appConfig.Shared.Gender.FEMALE}"
          src="https://cdn.cureskin.com/app/img/female_filled.svg"
          alt="female deselected" />
        <div class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800"
          i18n="@@female"
        [ngClass]="{'tw-opacity-30': gender === appConfig.Shared.Gender.MALE}"> Female </div>
      </div>
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 male"
        (click)="markGenderTo(appConfig.Shared.Gender.MALE)">
        <img class="tw-w-[88px] tw-h-auto tw-opacity-40 tw-grayscale"
          [ngClass]="{'tw-hidden': gender !== appConfig.Shared.Gender.FEMALE}"
          src="https://cdn.cureskin.com/app/img/male_plain.svg"
          alt="male deselected" />
        <img class="tw-w-[88px] tw-h-auto tw-grayscale"
          [ngClass]="{'tw-hidden': gender === appConfig.Shared.Gender.MALE || gender === appConfig.Shared.Gender.FEMALE}"
          src="https://cdn.cureskin.com/app/img/male_plain.svg"
          alt="male inactive" />
        <img class="tw-w-[88px] tw-h-auto"
          [ngClass]="{'tw-hidden': gender !== appConfig.Shared.Gender.MALE}"
          src="https://cdn.cureskin.com/app/img/male_filled.svg"
          alt="male active" />
        <div class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800"
          i18n="@@male"
        [ngClass]="{'tw-opacity-30': gender === appConfig.Shared.Gender.FEMALE}"> Male </div>
      </div>
    </div>
    @if (saveGenderInfo && gender === "None" ) {
      <div class="tw-flex tw-mt-2"
        id="genderError">
        <img src="/assets/images/warn-err.png"
          style="height: 18px"
          alt="warning" />
        <div class="tw-text-orange-500 tw-text-300 tw-ml-1"
        i18n="@@enterGender"> Select your gender </div>
      </div>
    }
    <div class="tw-mt-6 tw-font-lexend tw-text-gray-800 tw-mb-2 tw-text-200"
      [ngClass]="conn.getClassBasedOnLanguagePreference()"
    i18n="@@enterYourAge"> Enter your age </div>
    <div class="tw-flex tw-items-center">
      <input class="tw-h-12 tw-flex tw-bg-gray-80 tw-rounded-2.5 tw-border tw-border-solid tw-border-gray-300 tw-m-0 placeholder:tw-text-300 placeholder:tw-font-normal placeholder:tw-text-left tw-w-28 tw-font-body tw-text-300 tw-text-gray-800 tw-px-3"
        [ngClass]='{"tw-border-teal-400": age, "tw-border-orange-500":!age && saveGenderInfo}'
        #ageInput=""
        name="age"
        [(ngModel)]="age"
        pattern="[0-9]*"
        (input)="sanitizeAgeInput($event)"
        autocomplete="off"
        type="text"
        inputmode="numeric"
        autofocus="autofocus"
        (keydown)="commonUtilityHelper.limitInputByMaxDigit($event, 2)"
        maxlength="2"
        id="ageInput"
        placeholder="Age"
        i18n-placeholder="@@age"
        (paste)="onInputPaste($event)" />
    </div>
    @if (ageError || (saveGenderInfo && !age)) {
      <div class="tw-flex tw-mt-2"
        id="ageError">
        <img src="/assets/images/warn-err.png"
          style="height: 18px"
          alt="warning" />
        @if (ageErrorMessage === GenderFormErrorMessages.underAged) {
          <div
            class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@ageErrorUnderageV2">As you are under-age, presence and consent of your parent is required. Sorry, you will not be able to proceed further.</div>
        }
        @if (ageErrorMessage === GenderFormErrorMessages.invalidAge) {
          <div
            class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@ageErrorInvalidAgeV2">Please enter a valid age.</div>
        }
        @if (ageErrorMessage === GenderFormErrorMessages.enterAge || (!ageErrorMessage && saveGenderInfo && !age)) {
          <div
            class="tw-text-orange-500 tw-text-300 tw-ml-1"
          i18n="@@enterAgeV2">Enter your age to continue</div>
        }
      </div>
    }
  </div>
  <footer class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-p-6 tw-mt-6 tw-bg-white">
    <button csButton
      id="continueBtn"
      type="button"
      class="tw-w-full"
      [loading]="loading"
      (click)="updateGender()"><span i18n="@@continueNew">Continue</span>
    </button>
  </footer>
</div>
